import { useEffect, useState } from 'react'
import { syncAll, type SyncProgress } from '@/db/sync'
import clsx from 'clsx'

interface Props {
  onDone?: () => void
  autoStart?: boolean
}

export default function SyncBar({ onDone, autoStart = false }: Props) {
  const [progress, setProgress] = useState<SyncProgress | null>(null)
  const [running, setRunning] = useState(false)

  const start = async () => {
    if (running) return
    setRunning(true)
    const result = await syncAll((p) => setProgress(p))
    setProgress(result)
    setRunning(false)
    if (result.phase === 'done') onDone?.()
  }

  useEffect(() => {
    if (autoStart) start()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoStart])

  return (
    <div className="flex items-center gap-3 text-sm">
      <button
        onClick={start}
        disabled={running}
        className={clsx(
          'px-3 py-1.5 rounded-md border transition-colors',
          running
            ? 'border-stone-200 text-stone-400'
            : 'border-stone-300 hover:bg-stone-100 text-stone-700',
        )}
      >
        {running ? 'Syncing…' : 'Sync now'}
      </button>
      {progress && (
        <span
          className={clsx(
            'text-xs',
            progress.phase === 'error' ? 'text-red-600' : 'text-stone-600',
          )}
        >
          {progress.message}
        </span>
      )}
    </div>
  )
}
